<div class="lock_wrapper">
    <mat-icon class="form_field_lock_icon">lock</mat-icon>
</div>
